import { render } from "./respondent.vue?vue&type=template&id=58c71584&scoped=true"
import script from "./respondent.vue?vue&type=script&lang=js"
export * from "./respondent.vue?vue&type=script&lang=js"

import "./respondent.vue?vue&type=style&index=0&id=58c71584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c71584"]])

export default __exports__